import { ISystemCollection } from "@dl/declarations";
import * as yup from "yup";

export const LIMITS = {
  ITEMS: {
    MIN: 1,
    MAX: 100,
  },
};

export type CollectionFormData = {
  _id?: string;
  subtype: string;
} & Pick<
  ISystemCollection,
  "name" | "description" | "max_items" | "status" | "collection_type"
>;

export const initialValues: CollectionFormData = {
  name: "",
  description: "",
  subtype: "",
  max_items: 100,
  status: "released",
  collection_type: "Story",
};

export const collectionSchema = yup.object().shape({
  name: yup.string().required().label("Name"),
  description: yup.string().label("Description"),
  max_items: yup
    .number()
    .min(LIMITS.ITEMS.MIN)
    .max(LIMITS.ITEMS.MAX)
    .required()
    .label("Max Items"),
  status: yup.string().required().label("Status"),
  collection_type: yup.string().required().label("Collection Type"),
  subtype: yup.string().required().label("Subtype"),
});

export const collectionItemSchema = yup.object().shape({
  item_ref_type: yup
    .string()
    .oneOf(["Event", "Report"])
    .required()
    .label("Category"),
  item: yup.mixed().required().label("Item"),
});
